module.exports = {"label":{"select_recording":"Select a recording"}}